import { css } from '@repo/panda/css';

export const heroActionEditorModalClass = css({
    width: { base: '[calc(100vw - 16px)]', sm: '[calc(100vw - 24px)]', lg: '[1280px]' },
    maxWidth: { base: '[calc(100vw - 16px)]', sm: '[calc(100vw - 24px)]', lg: '[1280px]' },
    height: '[min(920px, calc(100dvh - 64px))]',
    maxHeight: '[min(920px, calc(100dvh - 64px))]',
    borderRadius: '24',
    padding: '0',
    gap: '0',
    overflow: 'hidden',
    '& > div': {
        display: 'flex',
        flexDirection: 'column',
        height: 'full',
        minHeight: '[0]',
        overflow: 'hidden',
    },
});

export const heroActionEditorShellStyles = css({
    display: 'flex',
    flexDirection: 'column',
    height: 'full',
    minHeight: '[0]',
    backgroundColor: 'black',
});

export const modalHeadStyles = css({
    display: 'grid',
    gridTemplateColumns: '[1fr auto]',
    gap: '16',
    alignItems: 'center',
    padding: '[20px 20px 16px 28px]',
    borderBottom: '[1px solid]',
    borderBottomColor: 'whiteAlpha.10',
    flexShrink: 0,
});

export const headStackStyles = css({
    display: 'flex',
    flexDirection: 'column',
    gap: '4',
    minWidth: '[0]',
});

export const headEyebrowStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: '8',
    fontSize: '[11px]',
    lineHeight: '[16px]',
    fontWeight: '[500]',
    letterSpacing: '[0.75px]',
    textTransform: 'uppercase',
    color: 'whiteAlpha.40',
});

export const headEyebrowDotStyles = css({
    width: '[4px]',
    height: '[4px]',
    borderRadius: 'full',
    backgroundColor: 'whiteAlpha.40',
});

export const headTitleStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: '12',
    minWidth: '[0]',
});

export const titleIconStyles = css({
    width: '[36px]',
    height: '[36px]',
    borderRadius: '10',
    backgroundColor: '[rgba(231, 255, 12, 0.12)]',
    display: 'grid',
    placeItems: 'center',
    flexShrink: 0,
});

export const headTitleTextStyles = css({
    minWidth: '[0]',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

export const headTagStripStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: '6',
    flexWrap: 'wrap',
    marginTop: '2',
});

export const externalIdChipStyles = css({
    gap: '6',
    maxWidth: '[220px]',
    color: 'whiteAlpha.80',
    fontFamily: 'mono',
    letterSpacing: '[0]',
    textTransform: 'none',
});

export const externalIdValueStyles = css({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

export const headActionsStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: '8',
});

export const modalBodyStyles = css({
    flex: '1',
    display: 'grid',
    gridTemplateColumns: { base: '[1fr]', lg: '[380px minmax(0, 1fr)]' },
    minHeight: '[0]',
    overflow: 'hidden',
});

export const colMetaStyles = css({
    padding: '[20px 24px 24px]',
    borderRight: { lg: '[1px solid]' },
    borderRightColor: { lg: 'whiteAlpha.10' },
    borderBottom: { base: '[1px solid]', lg: '[none]' },
    borderBottomColor: { base: 'whiteAlpha.10' },
    overflowY: 'auto',
});

export const generationPanelStyles = css.raw({
    borderTop: '[1px solid]',
    borderTopColor: 'whiteAlpha.10',
    paddingTop: '16',
});

export const generationStatusBannerStyles = css({
    minHeight: '[0]',
    padding: '8',
    fontSize: 'xs',
    lineHeight: '[16px]',
});

export const colPinsStyles = css({
    padding: '[20px 24px 24px]',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '[0]',
    overflow: 'hidden',
});

export const pinSectionHeadStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12',
    flexWrap: 'wrap',
    marginBottom: '12',
});

export const tabHintStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: '6',
    color: 'whiteAlpha.60',
    fontSize: '[12px]',
    lineHeight: '[16px]',
});

export const pinTabPanelStyles = css({
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    minHeight: '[0]',
    overflow: 'hidden',
});

export const modalFootStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12',
    flexWrap: 'wrap',
    padding: '[16px 24px]',
    borderTop: '[1px solid]',
    borderTopColor: 'whiteAlpha.10',
    flexShrink: 0,
});

export const footLeftStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: '8',
    color: 'whiteAlpha.40',
    fontSize: '[12px]',
    lineHeight: '[16px]',
});

export const orderedPinEditorStyles = css.raw({
    flex: '1',
    minHeight: '[0]',
});

export const composerStyles = css({
    display: 'grid',
    gridTemplateColumns: { base: '[1fr]', md: '[minmax(0, 1fr) minmax(220px, 1fr)]' },
    gap: '8',
    flexShrink: 0,
});

export const composerExternalStyles = css.raw({
    minWidth: '[0]',
});

export const pinListWrapStyles = css({
    flex: '1',
    minHeight: '[0]',
    marginX: '[-8px]',
});

export const pinListContentStyles = css({
    paddingLeft: '8',
    paddingRight: '16',
    paddingBottom: '8',
});

export const pinListStyles = css({
    display: 'flex',
    flexDirection: 'column',
    gap: '6',
    listStyle: 'none',
    margin: '0',
    padding: '0',
});

export const emptyStateStyles = css.raw({
    padding: '32',
    textAlign: 'center',
    borderRadius: '12',
    border: '[1px dashed]',
    borderColor: 'whiteAlpha.10',
    backgroundColor: 'whiteAlpha.5',
});

export const orderedPinRowStyles = ({ isDragging, isDropTarget }: { isDragging: boolean; isDropTarget: boolean }) =>
    css({
        display: 'grid',
        gridTemplateColumns: '[24px 44px 1fr auto]',
        alignItems: 'center',
        gap: '12',
        padding: '12',
        borderRadius: '12',
        border: '[1px solid]',
        borderColor: isDropTarget ? 'whiteAlpha.60' : '[transparent]',
        backgroundColor: isDragging ? '[rgba(231, 255, 12, 0.06)]' : 'whiteAlpha.5',
        opacity: isDragging ? 0.85 : 1,
        transition: '[background 160ms ease-out]',
        _hover: {
            backgroundColor: isDragging ? '[rgba(231, 255, 12, 0.06)]' : 'whiteAlpha.10',
            '& [data-pin-actions]': { opacity: '1' },
        },
        '& [data-pin-actions]': { opacity: isDragging ? '1' : '0' },
    });

export const dragHandleStyles = css({
    display: 'grid',
    placeItems: 'center',
    width: '[24px]',
    height: '[24px]',
    borderRadius: '6',
    color: 'whiteAlpha.40',
    cursor: 'grab',
    transition: '[all 160ms ease-out]',
    _hover: { color: 'white', backgroundColor: 'whiteAlpha.10' },
    _active: { cursor: 'grabbing' },
});

export const pinMetaStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: '8',
    overflow: 'hidden',
    fontFamily: 'mono',
    fontSize: '[12px]',
    lineHeight: '[16px]',
    color: 'whiteAlpha.60',
});

export const pinIdChipStyles = css({
    flexShrink: 0,
    color: 'whiteAlpha.80',
    backgroundColor: 'whiteAlpha.5',
    padding: '[1px 6px]',
    borderRadius: '4',
});

export const pinMetaSepStyles = css({
    color: 'whiteAlpha.40',
    flexShrink: 0,
});

export const pinMetaTextStyles = css({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

export const warningStyles = css({
    color: 'yellow.100',
});

export const pinStyles = css({
    color: 'whiteAlpha.70',
});

export const pinThumbStyles = css({
    width: '[44px]',
    height: '[44px]',
    borderRadius: '8',
    overflow: 'hidden',
    backgroundColor: 'whiteAlpha.10',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const pinThumbImageClass = css({
    width: 'full',
    height: 'full',
    objectFit: 'cover',
});

export const pinThumbFallbackStyles = css({
    color: 'whiteAlpha.80',
    fontSize: '[14px]',
    fontWeight: '[500]',
});

export const orderedPinTextContainerStyles = css({
    minWidth: '[0]',
    display: 'flex',
    flexDirection: 'column',
    gap: '2',
});

export const orderedPinActionsStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: '2',
    flexShrink: 0,
    transition: '[opacity 160ms ease-out]',
});

export const selectPinOptionStyles = css.raw({
    minWidth: '[0]',
    width: 'full',
});

export const orderedPinTitleStyles = css({
    color: 'whiteAlpha.90',
    minWidth: '[0]',
});

export const orderedPinSubtitleStyles = css({
    color: 'whiteAlpha.50',
    minWidth: '[0]',
    fontFamily: 'mono',
});
